import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Link } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/seo';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout mdxType="Layout">
      <SEO title="About" mdxType="SEO" />
      <h1>{`About`}</h1>
      <p>{`This site started at the monthly civic hackathon of the `}<a parentName="p" {...{
          "href": "https://github.com/detroit-urban-tech-meetup"
        }}>{`Detroit Urban Tech Meetup`}</a>{`.`}</p>
      <p>{`The principal motivation is to build a friendly "front-end" to the Detroit zoning code; currently living as a `}<a parentName="p" {...{
          "href": "https://detroitmi.gov/sites/detroitmi.localhost/files/2018-11/ZONING%20ORD%2010-14-18.pdf"
        }}>{`very large PDF`}</a>{` on the city's website.`}</p>
      <h2>{`FAQ`}</h2>
      <h3>{`What's a zoning code?`}</h3>
      <blockquote>
        <p parentName="blockquote"><a parentName="p" {...{
            "href": "https://en.wikipedia.org/wiki/Zoning"
          }}>{`Wikipedia says`}</a>{`: Zoning is the process of dividing land in a municipality into zones (e.g. residential, industrial) in which certain land uses are permitted or prohibited.`}{`[1]`}{` In addition, the sizes, bulk, and placement of buildings may regulated.`}</p>
      </blockquote>
      <h3>{`How is this site built?`}</h3>
      <blockquote>
        <p parentName="blockquote">{`This is a `}<a parentName="p" {...{
            "href": "https://www.gatsbyjs.org"
          }}>{`Gatsby site`}</a>{` which uses `}<a parentName="p" {...{
            "href": "https://www.airtable.com"
          }}>{`Airtable`}</a>{` as a back-end for organizing the zoning data into a relational database.`}</p>
      </blockquote>
      <h3>{`How can I contribute to this site?`}</h3>
      <blockquote>
        <p parentName="blockquote">{`There's a couple ways to help! You can help fill out the `}<a parentName="p" {...{
            "href": "https://airtable.com/invite/l?inviteId=invBcLP4bIHK6r4Xk&inviteToken=220a85cbf3a63ee6b76c80a812a4da179577d7c88d1b4a6cc801be33783c6709"
          }}>{`Airtable base`}</a>{` where we're trying to structure the zoning data into a spreadsheet format. (That's a read-only link; please contact `}<a parentName="p" {...{
            "href": "mailto:james.mcbroom@gmail.com"
          }}>{`Jimmy McBroom`}</a>{` for an editor link.)`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`If you're interested in developing this site, take a look at the `}<a parentName="p" {...{
            "href": "https://github.com/detroit-urban-tech-meetup/zoning-guide-detroit"
          }}>{`GitHub repository!`}</a>{`. If you can't figure out where to get started, please feel free to open a new issue.`}</p>
      </blockquote>
      <h2>{`Contributors`}</h2>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/CR96"
          }}>{`Corey R.`}</a></li>
        <li parentName="ul">{`Isaac G.`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "https://github.com/jmcbroom"
          }}>{`Jimmy M.`}</a></li>
        <li parentName="ul">{`Rita C.`}</li>
        <li parentName="ul">{`Xilin Z.`}</li>
      </ul>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      